<div id="container">
    <div id="content">
        <div id="headerContainer">
            <h4 class="mainDarkBlueText normalFontWeight">
                {{ "ACTIVE_USERS_PER_HOUR" | translate }}
            </h4>
            <statistics-png-download-btn [widget]="this" />
        </div>

        <div id="chartContainer">
            <canvas id="activeUsersPerHourChart" height="290px"></canvas>
        </div>
    </div>
</div>
